import { useState } from "react";
import type { EventId, PlanEvent } from "../../../shared/types";
import type { UpdateEventData } from "../types/event-form-types";

interface UseEventEditingReturn {
  readonly editingField: string | null;
  readonly editValue: string;
  startEdit: (field: string, value: string) => void;
  saveEdit: () => void;
  setEditValue: (value: string) => void;
}

export function useEventEditing(
  event: PlanEvent,
  onUpdate: (id: EventId, updates: UpdateEventData) => void,
): UseEventEditingReturn {
  const [editingField, setEditingField] = useState<string | null>(null);
  const [editValue, setEditValue] = useState("");

  function startEdit(field: string, value: string) {
    setEditingField(field);
    setEditValue(value);
  }

  function saveEdit() {
    if (!editingField) return;

    let updates: UpdateEventData = {};

    if (editingField === "title") {
      updates = { ...updates, title: editValue.trim() };
    } else if (editingField === "description") {
      updates = { ...updates, description: editValue };
    } else if (editingField === "notes") {
      updates = { ...updates, notes: editValue };
    }

    onUpdate(event.id, updates);
    setEditingField(null);
    setEditValue("");
  }

  return {
    editingField,
    editValue,
    startEdit,
    saveEdit,
    setEditValue,
  };
}
